import React from "react";
import { Box, FormControl, InputLabel, MenuItem, Select, TextField } from "@material-ui/core";
import { ReportFiltersType } from "./FlaggedContent";

interface ReportFiltersProps {
    filters: ReportFiltersType;
    setFilters: React.Dispatch<React.SetStateAction<ReportFiltersType>>;
    sortOrder: "newest" | "oldest";
    setSortOrder: (v: "newest" | "oldest") => void;
    dateRange: "all" | "24h" | "7d" | "30d";
    setDateRange: (v: "all" | "24h" | "7d" | "30d") => void;
    activeTab: number;
}

export const ReportFilters: React.FC<ReportFiltersProps> = ({
    filters,
    setFilters,
    sortOrder,
    setSortOrder,
    dateRange,
    setDateRange,
    activeTab,
}) => {

    const getFilterLabel = (activeTab: number): string => {
        switch (activeTab) {
            case 1:
                return "Post ID";
            case 2:
                return "Profile ID";
            case 3:
                return "Comment ID";
            case 4:
                return "Appeal ID";
            default:
                return "Profile or User ID";
        }
    };

    function getFilterKeyByTab(tab: number): keyof ReportFiltersType {
        switch (tab) {
            case 1: return "postId";
            case 2: return "profileId";
            case 3: return "commentId";
            case 4: return "appealId";
            default: return "postId";
        }
    }

    function getStatusByTab(tab: number) {
        switch (tab) {
            case 1: return { value: "postDeleted", label: "Post Banned" };
            case 2: return { value: "userDeleted", label: "User Banned" };
            case 3: return { value: "commentDeleted", label: "Comment Banned" };
            default: return { value: "", label: "" };
        }
    }

    const { value: reportTypeStatus, label: reportTypeLabel } = getStatusByTab(activeTab);

    return (
        <Box display="flex" alignItems="center" flexWrap="wrap" style={{ gap: "16px" }}>
            {/* Status */}
            <FormControl variant="outlined" size="small" style={{ minWidth: 120 }}>
                <InputLabel style={{ color: "#fff" }}>Status</InputLabel>
                <Select
                    value={filters.status}
                    onChange={e => setFilters({ ...filters, status: e.target.value as string })}
                    label="Status"
                    style={{ color: "#fff" }}
                >
                    <MenuItem value="" style={{ color: "#fff" }}>All</MenuItem>
                    <MenuItem value="open" style={{ color: "#fff" }}>Open</MenuItem>
                    <MenuItem value="resolved" style={{ color: "#fff" }}>Resolved</MenuItem>
                    <MenuItem value={reportTypeStatus} style={{ color: "#fff" }}>{reportTypeLabel}</MenuItem>
                </Select>
            </FormControl>

            {/* Dynamic filter by ID */}
            <TextField
                variant="outlined"
                size="small"
                label={getFilterLabel(activeTab)}
                value={filters[getFilterKeyByTab(activeTab)]}
                onChange={e =>
                    setFilters(prev => ({
                        ...prev,
                        [getFilterKeyByTab(activeTab)]: e.target.value,
                    }))
                }
                style={{ minWidth: 200 }}
                InputProps={{ style: { color: "#fff" } }}
                InputLabelProps={{ style: { color: "#fff" } }}
            />

            {/* Sort order */}
            <FormControl variant="outlined" size="small" style={{ minWidth: 170 }}>
                <InputLabel style={{ color: "#fff" }}>Sort by date</InputLabel>
                <Select
                    value={sortOrder}
                    onChange={e => setSortOrder(e.target.value as "newest" | "oldest")}
                    label="Sort by date"
                    style={{ color: "#fff" }}
                >
                    <MenuItem value="newest" style={{ color: "#fff" }}>Newest first</MenuItem>
                    <MenuItem value="oldest" style={{ color: "#fff" }}>Oldest first</MenuItem>
                </Select>
            </FormControl>

            {/* Date range */}
            <FormControl variant="outlined" size="small" style={{ minWidth: 170 }}>
                <InputLabel style={{ color: "#fff" }}>Date range</InputLabel>
                <Select
                    value={dateRange}
                    onChange={e => setDateRange(e.target.value as "all" | "24h" | "7d" | "30d")}
                    label="Date range"
                    style={{ color: "#fff" }}
                >
                    <MenuItem value="all" style={{ color: "#fff" }}>All time</MenuItem>
                    <MenuItem value="24h" style={{ color: "#fff" }}>Last 24 hours</MenuItem>
                    <MenuItem value="7d" style={{ color: "#fff" }}>Last 7 days</MenuItem>
                    <MenuItem value="30d" style={{ color: "#fff" }}>Last 30 days</MenuItem>
                </Select>
            </FormControl>
        </Box>
    );
};
